import {getUserByToken} from "../api/user";
import EventBus from '../api/event-bus.js';
export default class Auth {
  constructor() {
    this.currentUser = null;
    this.groups = [];
    let self = this;
    if(localStorage.getItem("JSTOKEN") != undefined) {
      getUserByToken().then(function(user){
        self.currentUser = user;
        console.log("AUTH logged on from constructor");
        EventBus.$emit("logon", true);
      });
    }
  }

  setUser(user) {
    this.currentUser = user;
  }
}



// WEBPACK FOOTER //
// ./src/store/auth.js